<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div>
      <span class="action-name">{{ action }}</span
      ><span class="records"> ({{ totalRecords || 0 }} records found)</span>
    </div>
    <div class="input-wrapper">
      <app-console-search
        [findOptions]="findOptions"
        [showDateRange]="showDateRange"
        [headercount]="headercount"
        [showHideHeaderColumnCount]="true"
        (clearSearchBoxEvent)="clearSearchBox()"
        (clearFilterEvent)="clearFilter()"
        (applyFilterByFieldEvent)="applyFilterByField($event)"
        (showHideColumnsEvent)="showHideColumns()"
        [initialFromDate]="fromDate" 
        [initialToDate]="toDate"
        [isAIInteractions]="true"
        (resetDateRangeEvent)="resetDateRange($event)"
        (applySelectedDateRangeEvent)="applySelectedDateRange($event)"
      ></app-console-search>
    </div>
    <p-table
      [columns]="cols"
      [value]="auditList"
      [lazy]="true"
      (onLazyLoad)="loadAudits($event)"
      dataKey="id"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [totalRecords]="totalRecords"
      [loading]="loading"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      [scrollable]="true"
      [style]="{ width: '100%' }"
      [scrollHeight]="innerHeight + 'vh'"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="!col?.hide">
              {{ col.label }}
              <span class="fts">
                <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                  <ng-container *ngIf="col.filterVals; else notSelected">
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                  </ng-container>
                  <ng-template #notSelected>
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                  </ng-template>
                </span>

                <span class="sort" (click)="sortByColumn(col.name)">
                  <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                    <ng-container *ngIf="col.isAsc; else falseBlock">
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                    </ng-container>
                    <ng-template #falseBlock>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                    </ng-template>
                  </ng-container>

                  <ng-template #others>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                  </ng-template>
                </span>
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" style="height: 2.875rem">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              {{ col.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">No Data Available</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
